module.exports = __webpack_public_path__ + "static/media/historico.759c98b9.svg";